import React from 'react';
import PropTypes from 'prop-types';
import { HOUSE_HOLD_CONFIG } from './house-hold.config';
import MInfographic from '../../molecules/_molecules.infographic';

export default function OHouseHoldInfographic({ className }) {
	return (
		<article className={`o-infographic-household ${className}`}>
			{HOUSE_HOLD_CONFIG.infographic.map(item => (
				<div
					key={item.title}
				>
					<MInfographic
						title={item.title}
						img={item.img}
						description={item.description}
					/>
				</div>
			))}
		</article>
	);
}

OHouseHoldInfographic.propTypes = {
	className: PropTypes.string,
};
OHouseHoldInfographic.defaultProps = {
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/house_hold/_organisme.household-infographic.js